import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import Style from './widgetTab.scss';
import C from '../../constants/scoreBoard';
import C_R from '../../constants/routes';
import styled from 'styled-components';
import Cx from 'classnames';
import C_SR from '../../constants/SRview';


const StyledRequestListItemMobile = styled.div`
        color: ${props => props.theme.textColor};
        border-bottom: 1px solid ${props => props.theme.borderColor};
        padding: 15px;
        .requestListItemDetails {
            border-color: ${props => props.theme.brandColor};
        }
`;

/**
 *returns a react object of the widget list item
 */
const MobileListItem = function ({listItemId, listItemData,listBadgesData, listColumnsData, isPendingActionItem, intlObject}) {
    let columns =  listColumnsData.slice(0, 1).map((column)=> {
        if(column) {
            return (
                <span key ={column.key}  className={Cx(Style.requestListItemDetails,'requestListItemDetails')}><span
                    id={`${listItemId}_${column.key}`}>{column.valueCaption.substring(0, 10)}</span></span>
            )
        }

    });
    let badges = listBadgesData.slice(0, 1).map((badge)=> {
        if(badge) {
            return (
                <span  key ={badge.key} className={Cx(Style.requestListItemDetails,'requestListItemDetails')}><span
                    id={`${listItemId}_${badge.key}`}>{badge.valueCaption}</span></span>
            )
        }

    });
    let reqLink;
    let titleValue;
    if (isPendingActionItem) {
        reqLink = `${C_R.ACTION_PATH}/${listItemId}`;
        titleValue = listItemData[C.SR_TITLE].valueCaption;
    } else {
        reqLink = `${C_R.SR_VIEW}/${listItemId}`;
        titleValue = listItemData[C.TITLE].valueCaption;
    }
    let icon;
    if (listItemData.sr_type) {
        icon = listItemData.sr_type.value == C_SR.SR_TYPE_INCIDENT ?
            <span className={Cx('iconIssue', Style.listItemIcon, 'IssueIcon')}></span> :
            <span className={Cx('iconIssue', Style.listItemIcon, 'iconRequest')}></span>;
    }

    return (
        <Link to={reqLink} className={Style.noDecoration}>
            <StyledRequestListItemMobile className={Cx(Style.requestListItemMobile, 'clearfix')}>
                <div className={Style.requestListItemSubject}>
                    {icon}
                    <strong><span id={`${listItemId}_num`} className={Style.srId}>{`${intlObject['ssp.idPrefix']} ${listItemId}: `}</span></strong>
                    <span id={`${listItemId}_title`}>{titleValue}</span>
                </div>
                {columns}
                {badges}
            </StyledRequestListItemMobile>
        </Link>
    )
};

MobileListItem.propTypes = {
    listItemId: PropTypes.string.isRequired,
    listItemData: PropTypes.object.isRequired,
    listBadgesData: PropTypes.array.isRequired,
    listColumnsData: PropTypes.array.isRequired,
    isPendingActionItem: PropTypes.bool.isRequired,
    intlObject:PropTypes.object.isRequired
};

export default MobileListItem;




// WEBPACK FOOTER //
// ./components/Scoreboard/mobileListItem.js